import { render, staticRenderFns } from "./BibleStudyPlans.vue?vue&type=template&id=0462db28&"
import script from "./BibleStudyPlans.vue?vue&type=script&lang=js&"
export * from "./BibleStudyPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports